// extracted by mini-css-extract-plugin
module.exports = {"block":"Close_block__Yi90T","isDisabled":"Close_isDisabled__pKPBr","fadeOut":"Close_fadeOut__CaUdV"};